import { PRODUCT_TYPE } from '@ahmdigital/constants';
import { ReactNode } from 'react';

import { STEP_SLUG } from './constants';
import AboutYou from './steps/about-you';
import ChooseYourCover from './steps/choose-your-cover';
import ServiceSelectionWithDataLoader from './steps/service-selection-with-data-loader';
import type { StepSlug } from './types';

const stepComponents: Record<StepSlug, ReactNode> = {
  [STEP_SLUG.ABOUT_YOU]: <AboutYou />,
  [STEP_SLUG.CHOOSE_COVER]: <ChooseYourCover />,
  [STEP_SLUG.EXTRAS]: <ServiceSelectionWithDataLoader productType={PRODUCT_TYPE.EXTRAS} />,
  [STEP_SLUG.HOSPITAL]: <ServiceSelectionWithDataLoader productType={PRODUCT_TYPE.HOSPITAL} />,
};

const getStepComponent = (slug: StepSlug) => stepComponents[slug];

export default getStepComponent;
